import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPolygonsSizeS from './IconPolygons_size_s';

const props: CreateIconArguments = {
  l: IconPolygonsSizeS,
  m: IconPolygonsSizeS,
  s: IconPolygonsSizeS,
  xs: IconPolygonsSizeS,
  name: 'IconPolygons',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
